import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of, tap } from 'rxjs';
import { FeatureFlagsService } from '~modules/administration/feature-flags.service';


@Injectable({
    providedIn: 'root'
})
export class FeatureFlagGuard {

  constructor(
    private readonly featureFlagsService: FeatureFlagsService,
    private readonly router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    if (route.children && route.children.length > 0) {
      return of(true);
    }

    const flagKey = route.data['featureFlag'] as string | null;

    if (!flagKey) {
      return of(true); // authorize if no key is passed to the guard
    }

    return this.featureFlagsService.isEnabled(flagKey).pipe(
      tap((enabled) => {
        if (!enabled) {
          this.router.navigate(['/']);
        }
      })
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
